import axios from '@/util/request'

// /com/had-login/aspiration/aspiration-draft/previewAdmit
export const previewAdmitDraft = (params) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-draft/previewAdmit',
        method: 'get',
        params
    })
}

// /com/had-login/service-one-to-one/getServiceOneToOnePage
// 一对一服务记录列表 管理
export const getServiceOneToOnePage = (data) => {
    return axios({
        url: '/com/had-login/service-one-to-one/getServiceOneToOnePage',
        method: 'post',
        data: data
    })
}
// /com/had-login/service-one-to-one/getServiceOneToOneInfo
// 一对一服务记录详情
export const getServiceOneToOneInfo = (params) => {
    return axios({
        url: '/com/had-login/service-one-to-one/getServiceOneToOneInfo',
        method: 'get',
        params
    })
}
// /com/had-login/stu/student-info/getStudentDetail
// 查看单个详情
export const getStudentDetail = (params) => {
    return axios({
        url: '/com/had-login/stu/student-info/getStudentDetail',
        method: 'get',
        params
    })
}

//兴趣性格能力测试
// /com/had-login/service/assess/getAnswerServicePage
// 兴趣能力性格测评-所有用户的测评
export const getAnswerServicePage = (data) => {
    return axios({
        url: '/com/had-login/service/assess/getAnswerServicePage',
        method: 'post',
        data: data
    })
}

// /com/had-login/service/assess/getAnswerResult
// 测评结果详情
export const getAnswerResult = (params) => {
    return axios({
        url: '/com/had-login/service/assess/getAnswerResult',
        method: 'get',
        params
    })
}

//志愿结果
// /com/had-login/aspiration/aspiration-result/page
// 获取分页列表
export const aspirationresultpage = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-result/page',
        method: 'post',
        data
    })
}

// /com/had-login/aspiration/aspiration-result/saveActualAdmit
// 设置实录取
export const saveActualAdmit = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-result/saveActualAdmit',
        method: 'post',
        data
    })
}

// /com/had-login/specialty/specialty-info/getSpecialtyList
// 专业-获取列表全部(无需传分页参数)
export const getSpecialtyList = (data) => {
    return axios({
        url: '/com/had-login/specialty/specialty-info/getSpecialtyList',
        method: 'post',
        data
    })
}

// /com/had-login/service-consult/getServiceConsultPage
// 咨询预设列表 管理
export const getServiceConsultPage = (data) => {
    return axios({
        url: '/com/had-login/service-consult/getServiceConsultPage',
        method: 'post',
        data
    })
}

// /com/had-login/service-consult/saveServiceConsult
// 咨询预设新增修改
export const saveServiceConsult = (data) => {
    return axios({
        url: '/com/had-login/service-consult/saveServiceConsult',
        method: 'post',
        data
    })
}

// /com/had-login/service-consult/deleteServiceConsult
// 咨询预设删除
export const deleteServiceConsult = (params) => {
    return axios({
        url: '/com/had-login/service-consult/deleteServiceConsult',
        method: 'get',
        params
    })
}

// /com/had-login/assess-answer/getAnswerResultByUserId
// 指定用户的最新测评结果详情
export const getAnswerResultByUserId = (params) => {
    return axios({
        url: '/com/had-login/assess-answer/getAnswerResultByUserId',
        method: 'get',
        params
    })
}

// /com/had-login/cdkey/cdkey-info/pageRecord
// 激活码使用记录-分页列表
export const pageRecord = (data) => {
    return axios({
        url: '/com/had-login/cdkey/cdkey-info/pageRecord',
        method: 'post',
        data
    })
}

// /com/had-login/cdkey/cdkey-info/updateStatus
// 激活码使用记录-重置&禁用
export const updateStatus = (data) => {
    return axios({
        url: '/com/had-login/cdkey/cdkey-info/updateStatus',
        method: 'post',
        data
    })
}

// /com/had-login/cdkey/cdkey-info/saveBatchCdkey
// 激活码库-批量生成
export const saveBatchCdkey = (data) => {
    return axios({
        url: '/com/had-login/cdkey/cdkey-info/saveBatchCdkey',
        method: 'post',
        data
    })
}

// /com/had-login/cdkey/cdkey-info/page
// 激活码库-分页列表
export const page = (data) => {
    return axios({
        url: '/com/had-login/cdkey/cdkey-info/page',
        method: 'post',
        data
    })
}

// /com/had-login/service-expert-evaluate/getServiceExpertEvaluatePage
// 专家评价列表 管理
export const getServiceExpertEvaluatePage = (data) => {
    return axios({
        url: '/com/had-login/service-expert-evaluate/getServiceExpertEvaluatePage',
        method: 'post',
        data
    })
}

// /com/had-login/service-expert-evaluate/toExamine
// 专家评价审核
export const toExamine = (params) => {
    return axios({
        url: '/com/had-login/service-expert-evaluate/toExamine',
        method: 'get',
        params
    })
}

// /com/had-login/sys/sys-province/getProvincePage
// 省份查询列表
export const getProvincePage = (data) => {
    return axios({
        url: '/com/had-login/sys/sys-province/getProvincePage',
        method: 'post',
        data
    })
}

// /com/had-login/aspiration/aspiration-draft/getDraftList
// 草稿列表查询
export const getDraftList = (params) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-draft/getDraftList',
        method: 'get',
        params
    })
}

// /com/had-login/aspiration/aspiration-draft/setFormal
// 设为志愿方案
export const setFormal = (params) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-draft/setFormal',
        method: 'get',
        params
    })
}

// /com/had-login/aspiration/aspiration-draft/deleteDraft
// 删除志愿草稿
export const deleteDraft = (params) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-draft/deleteDraft',
        method: 'get',
        params
    })
}

// /com/had-login/aspiration/aspiration-draft/selectCollegeList
// 选择院校列表
export const selectCollegeList = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-draft/selectRecommendCollegeList',
        method: 'post',
        data
    })
}

// /com/had-login/aspiration/aspiration-analog/page
// 获取分页列表
export const aspirationanalogpage = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-analog/page',
        method: 'post',
        data
    })
}

// /com/had-login/aspiration/aspiration-draft/selectSpecialtyList
// 选择专业列表
export const selectSpecialtyList = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-draft/selectSpecialtyList',
        method: 'post',
        data
    })
}

// /com/had-login/aspiration/aspiration-draft/selectEqualScore
// 查询等位分成绩
export const selectEqualScore = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-draft/selectEqualScore',
        method: 'post',
        data
    })
}

// /com/had-login/shopp-order/getShoppOrderInfo
// 订单详情
export const getShoppOrderInfo = (params) => {
    return axios({
        url: '/com/had-login/shopp-order/getShoppOrderInfo',
        method: 'get',
        params
    })
}

// /com/had-login/service-one-to-one-consult/getServiceOneToOneConsultPage
// 咨询记录列表 管理
export const getServiceOneToOneConsultPage = (data) => {
    return axios({
        url: '/com/had-login/service-one-to-one-consult/getServiceOneToOneConsultPage',
        method: 'post',
        data
    })
}

// /com/had-login/service-one-to-one-consult/saveServiceOneToOneConsult
// 咨询记录新增修改
export const saveServiceOneToOneConsult = (data) => {
    return axios({
        url: '/com/had-login/service-one-to-one-consult/saveServiceOneToOneConsult',
        method: 'post',
        data
    })
}

// /com/had-login/service-one-to-one-consult/deleteServiceOneToOneConsult
// 咨询记录删除
export const deleteServiceOneToOneConsult = (params) => {
    return axios({
        url: '/com/had-login/service-one-to-one-consult/deleteServiceOneToOneConsult',
        method: 'get',
        params
    })
}

// /com/had-login/service-one-to-one-university/getServiceOneToOneUniversityPage
// 服务-一对一服务-高校列表 管理
export const getServiceOneToOneUniversityPage = (data) => {
    return axios({
        url: '/com/had-login/service-one-to-one-university/getServiceOneToOneUniversityPage',
        method: 'post',
        data
    })
}

// /com/had-login/service-one-to-one-university/deleteServiceOneToOneUniversity
// 服务-一对一服务-高校删除
export const deleteServiceOneToOneUniversity = (params) => {
    return axios({
        url: '/com/had-login/service-one-to-one-university/deleteServiceOneToOneUniversity',
        method: 'get',
        params
    })
}

// /com/had-login/admission/admission-plan/page
// 获取分页列表
export const pageplan = (data) => {
    return axios({
        url: '/com/had-login/admission/admission-plan/page',
        method: 'post',
        data
    })
}

// /com/had-login/service-one-to-one-university/saveServiceOneToOneUniversity
// 服务-一对一服务-高校新增修改
export const saveServiceOneToOneUniversity = (data, params) => {
    return axios({
        url: '/com/had-login/service-one-to-one-university/saveServiceOneToOneUniversity',
        method: 'post',
        data,
        params
    })
}

// /com/had-login/service-one-to-one-specialty/saveServiceOneToOneSpecialty
// 服务-一对一服务-专业新增修改
export const saveServiceOneToOneSpecialty = (data, params) => {
    return axios({
        url: '/com/had-login/service-one-to-one-specialty/saveServiceOneToOneSpecialty',
        method: 'post',
        data,
        params
    })
}

// /com/had-login/service-one-to-one-specialty/getServiceOneToOneSpecialtyList
// 服务-一对一服务-专业列表 管理
export const getServiceOneToOneSpecialtyList = (data) => {
    return axios({
        url: '/com/had-login/service-one-to-one-specialty/getServiceOneToOneSpecialtyList',
        method: 'post',
        data
    })
}

// POST /com/had-login/admission/admission-specialty/page
// 获取分页列表
export const pageadmissionspecialty = (data) => {
    return axios({
        url: '/com/had-login/admission/admission-specialty/page',
        method: 'post',
        data
    })
}

// /com/had-login/service-one-to-one-specialty/deleteServiceOneToOneSpecialtyType
// 服务-一对一服务-专业类别删除
export const deleteServiceOneToOneSpecialtyType = (params) => {
    return axios({
        url: '/com/had-login/service-one-to-one-specialty/deleteServiceOneToOneSpecialtyType',
        method: 'get',
        params
    })
}

// /com/had-login/service-one-to-one-specialty/deleteServiceOneToOneSpecialty
// 服务-一对一服务-专业删除
export const deleteServiceOneToOneSpecialty = (params) => {
    return axios({
        url: '/com/had-login/service-one-to-one-specialty/deleteServiceOneToOneSpecialty',
        method: 'get',
        params
    })
}

// /com/had-login/aspiration/aspiration-draft/save
// 保存志愿草稿
export const savedraft = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-draft/save',
        method: 'post',
        data
    })
}

// /com/had-login/service-one-to-one-consult/setApprove
// 咨询记审核 审核 0待审核 1已审核 2已拒绝
export const setApprove = (params) => {
    return axios({
        url: '/com/had-login/service-one-to-one-consult/setApprove',
        method: 'get',
        params
    })
}

// /com/had-login/aspiration/aspiration-result-assess/page
// 获取分页列表
export const pageaspirationresult = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-result-assess/page',
        method: 'post',
        data
    })
}

// /com/had-login/aspiration/aspiration-result-assess/expertAssess
// 专家评审
export const expertAssess = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-result-assess/expertAssess',
        method: 'post',
        data
    })
}

// /com/had-login/service-one-to-one-consult/getServiceOneToOneConsult3
// 咨询记录列表 管理前三条固定
export const getServiceOneToOneConsult3 = (params) => {
    return axios({
        url: '/com/had-login/service-one-to-one-consult/getServiceOneToOneConsult3',
        method: 'get',
        params
    })
}

// /com/had-login/stu/student-info/saveStudentScore
// 保存分数
export const saveStudentScore = (data) => {
    return axios({
        url: '/com/had-login/stu/student-info/saveStudentScore',
        method: 'post',
        data
    })
}

// /com/had-login/admission/admission-plan/pageUniversity
// 获取实录取院校(isCollege传1)&获取实录取专业
export const pageUniversity = (data) => {
    return axios({
        url: '/com/had-login/admission/admission-plan/pageUniversity',
        method: 'post',
        data
    })
}

// /com/had-login/aspiration/aspiration-plan/getPlanDetail
// 志愿方案详情(看院校&看专业)
export const getPlanDetail = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-plan/getPlanDetail',
        method: 'post',
        data
    })
}

// /com/had-login/sys/sys-province/getOneProvince
// 根据年份和省份(地区)id查询单个
export const getOneProvince = (params) => {
    return axios({
        url: '/com/had-login/sys/sys-province/getOneProvince',
        method: 'get',
        params
    })
}

// /com/had-login/specialty/specialty-info/getSpecialtyTree
// 获取专业类+专业树形结构（传name搜索,且只能搜专业(第三级)）
export const getSpecialtyTree = (params) => {
    return axios({
        url: '/com/had-login/specialty/specialty-info/getSpecialtyTree',
        method: 'get',
        params
    })
}

// /com/had-login/service-one-to-one-university/deleteServiceOneToOneUniversityByAdmitBatch
export const deleteServiceOneToOneUniversityByAdmitBatch = (params) => {
    return axios({
        url: '/com/had-login/service-one-to-one-university/deleteServiceOneToOneUniversityByAdmitBatch',
        method: 'get',
        params
    })
}

// /com/had-login/service-one-to-one-consult/updateConsultRemarks
// 修改备注
export const updateConsultRemarks = (data) => {
    return axios({
        url: '/com/had-login/service-one-to-one-consult/updateConsultRemarks',
        method: 'post',
        data
    })
}

// /com/had-login/sys-user-auth/authPage
// 授权列表
export const authPage = (data) => {
    return axios({
        url: '/com/had-login/sys-user-auth/authPage',
        method: 'post',
        data
    })
}

// /com/had-login/sys-user-auth/addUserAuth
// 新增授权
export const addUserAuth = (data) => {
    return axios({
        url: '/com/had-login/sys-user-auth/addUserAuth',
        method: 'post',
        data
    })
}

// /com/had-login/sys-user-auth/cancelUserAuth
// 取消授权
export const cancelUserAuth = (params) => {
    return axios({
        url: '/com/had-login/sys-user-auth/cancelUserAuth',
        method: 'get',
        params
    })
}

// /com/had-login/service-one-to-one/setVisibleSpecialty
// 专业可见 0不可见 1可见
export const setVisibleSpecialty = (params) => {
    return axios({
        url: '/com/had-login/service-one-to-one/setVisibleSpecialty',
        method: 'get',
        params
    })
}

// /com/had-login/service-one-to-one/setvisibleUniversity
// 高校可见 0不可见 1可见
export const setvisibleUniversity = (params) => {
    return axios({
        url: '/com/had-login/service-one-to-one/setvisibleUniversity',
        method: 'get',
        params
    })
}

// 草稿志愿详情
// /com/had-login/aspiration/aspiration-draft/getDraftPlanDetail
export const getDraftPlanDetail = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-draft/getDraftPlanDetail',
        method: 'post',
        data
    })
}

// /com/had-login/aspiration/aspiration-plan/save
// 保存志愿方案
export const saveaspirationplan = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-plan/save',
        method: 'post',
        data
    })
}

// /com/had-login/aspiration/aspiration-plan/examinePlan
// 审核
export const examinePlan = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-plan/examinePlan',
        method: 'post',
        data
    })
}

// /com/had-login/aspiration/aspiration-plan/previewAdmit
// 设为预录取
export const previewAdmit = (params) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-plan/previewAdmit',
        method: 'get',
        params
    })
}

// /com/had-login/aspiration/aspiration-draft/systemAssess
// 系统评审
export const systemAssess = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-draft/systemAssess',
        method: 'post',
        data
    })
}

// /com/had-login/aspiration/aspiration-plan/saveTemplete
// 添加到模版
export const saveTemplete = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-plan/saveTemplete',
        method: 'post',
        data
    })
}

// /com/had-login/aspiration/aspiration-plan/exportTemplate
// 方案Excel导出
export const exportTemplateData = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-plan/exportTemplateData',
        method: 'post',
        data,
    })
}

// POST /com/had-login/aspiration/aspiration-draft/selectCollegeSpecialtyList
export const selectCollegeSpecialtyList = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-draft/selectCollegeSpecialtyList',
        method: 'post',
        data,
    })
}

//POST com/had-login/mobile/admission-info/getAccumulateByScore
export const obtainRankingByScore = (data) => {
    return axios({
        url: '/com/had-login/mobile/admission-info/getAccumulateByScore',
        method: 'post',
        data,
    })
}

// /com/had-login/aspiration/aspiration-draft/selectCollegeOptionsList
// 选择专业组志愿列表(含院校
export const selectCollegeOptionsList = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-draft/selectCollegeOptionsList',
        method: 'post',
        data,
    })
}

// POST /com/had-login/aspiration/aspiration-draft/selectSpecialtyOptionsList
// 选择专业志愿列表(含院校+专业组)
export const selectSpecialtyOptionsList = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-draft/selectSpecialtyOptionsList',
        method: 'post',
        data,
    })
}

// POST /com/had-login/aspiration/aspiration-draft/selectSpecialtyOptionsListV2
// 选择专业志愿列表(含院校+专业组)
export const selectSpecialtyOptionsListV2 = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-draft/selectSpecialtyOptionsListV2',
        method: 'post',
        data,
    })
}

// POST /com/had-login/sys-user-service/saveServiceConfig
// 授权管理默认配置
export const saveAuthorizationManagement = (data) => {
    return axios({
        url: '/com/had-login/sys-user-service/saveServiceConfig',
        method: 'post',
        data,
    })
}

// GET /com/had-login/sys-user-service/getServiceConfig
// 授权管理默认配置
export const obtainAuthorizationManagement = (params) => {
    return axios({
        url: '/com/had-login/sys-user-service/getServiceConfig',
        method: 'get',
        params
    })
}

// GET /com/had-login/service-one-to-one/updateRepeat
// 1对1服务设置复读
export const setRepeat = (params) => {
    return axios({
        url: '/com/had-login/service-one-to-one/updateRepeat',
        method: 'get',
        params
    })
}

//POST /com/had-login/service-one-to-one/updateRepeatInfo
// 复读更新学生信息
export const repeatUpdateStudentInfo = (data) => {
    return axios({
        url: '/com/had-login/service-one-to-one/updateRepeatInfo',
        method: 'post',
        data,
    })
}


//POST /com/had-login/aspiration/aspiration-result-visit/addVisit
// 回访评价
export const returnVisit = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-result-visit/addVisit',
        method: 'post',
        data,
    })
}

//POST /com/had-login/aspiration/aspiration-result-visit/page
// 专家评价列表
export const returnVisitList = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-result-visit/page',
        method: 'post',
        data,
    })
}

// GET /com/had-login/aspiration/aspiration-result-visit/details
// 专家评价详情
export const returnVisitDetail = (params) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-result-visit/details',
        method: 'get',
        params
    })
}

// POST /com/had-login/aspiration/aspiration-result-visit/statistics
// 专家满意度
export const expertSatisfaction = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-result-visit/statistics',
        method: 'post',
        data,
    })
}


// /com/had-login/aspiration/aspiration-plan/removeByBatch
// 删除志愿方案
export const removeByBatch = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-plan/removeByBatch',
        method: 'post',
        data,
    })
}

// /com/had-login/aspiration/aspiration-draft/copy
// 复制草稿
export const copyDraft = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-draft/copy',
        method: 'post',
        data,
    })
}

// /com/had-login/aspiration/aspiration-draft/cancelFormal
// 取消设为志愿方案
export const cancelFormal = (params) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-draft/cancelFormal',
        method: 'get',
        params,
    })
}

// POST /com/had-login/aspiration/aspiration-draft/updateDraftPlanSort
// 草稿排序
export const updateDraftPlanSort = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-draft/updateDraftPlanSort',
        method: 'post',
        data,
    })
}

// /com/had-login/aspiration/aspiration-plan/setHidden
export const setHidden = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-plan/setHidden',
        method: 'post',
        data,
    })
}

// 修改草稿方案名称
export const updateDraftPlanName = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-draft/updateDraftPlanName',
        method: 'post',
        data,
    })
}

// 获取志愿模板列表
export const getVolunteerTemplatePlan = (data) => {
    return axios({
        url: '/com/had-login/template/volunteer-template-plan/getVolunteerTemplatePlan',
        method: 'post',
        data,
    })
}

// 获取模板方案详情
export const setTemplate = (data) => {
    return axios({
        url: '/com/had-login/template/volunteer-template-plan/setTemplate',
        method: 'post',
        data,
    })
}

// 获取模板方案详情
export const getTemplatePlanDetail = (data) => {
    return axios({
        url: '/com/had-login/template/volunteer-template-plan/getTemplatePlanDetail',
        method: 'post',
        data,
    })
}

// 修改模板方案名称
export const updateTemplateName = (data) => {
    return axios({
        url: '/com/had-login/template/volunteer-template-plan/updateTemplateName',
        method: 'post',
        data,
    })
}

// 删除模板方案
export const deleteTemplate = (data) => {
    return axios({
        url: '/com/had-login/template/volunteer-template-plan/deleteTemplate',
        method: 'post',
        data,
    })
}

// 选择支援模版添加到草稿志愿
export const addDraftPlanFromTemplate = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-draft/addDraftPlanFromTemplate',
        method: 'post',
        data,
    })
}